export default __webpack_public_path__ + "static/media/casir.83bc41ff.png";